import React, { useCallback } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { cn } from '@lyearn/style';
import { Popover, Touchable } from '@lyearn/ui';
import EmojiPicker from '@/components/EmojiPicker';

import Icon from '../Icon';
import { emojiSelectorStyles, emojiStyles } from './styles';
import { ReactionSelectorProps } from './types';

const PICKER_STYLES = {
  border: 'none',
};

function ReactionSelector(props: ReactionSelectorProps) {
  let { onSelect, icon, EmojiDefaultIcon, className } = props;
  const [open, { toggle }] = useToggle(false);

  const _onSelect = useCallback(
    (emoji: any) => {
      toggle(false);
      emoji.id && onSelect(emoji.id, emoji);
    },
    [onSelect, toggle],
  );

  return (
    <Popover open={open} onOpenChange={toggle}>
      <Popover.Button
        className={cn(
          className?.button || 'px-10',
          'flex h-full items-center border-border border-e hover:bg-bg-tertiary',
          emojiSelectorStyles,
        )}>
        <Touchable>
          <Icon EmojiDefaultIcon={EmojiDefaultIcon} icon={icon} />
        </Touchable>
      </Popover.Button>
      <React.Suspense fallback={null}>
        <Popover.Content className={emojiStyles} minWidth={30} position="bottom-start">
          <EmojiPicker style={PICKER_STYLES} onSelect={_onSelect} />
        </Popover.Content>
      </React.Suspense>
    </Popover>
  );
}

export default ReactionSelector;
